// @flow

export function parseJSONOrEmptyObject (jsonString: ?string): Object {
  if (!jsonString) return {}

  try {
    const parsed = JSON.parse(jsonString)

    return parsed
  } catch (error) {
    return {}
  }
}
